
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"setting-2","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M15 12a3 3 0 11-3-3 3 3 0 013 3z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M2 12.88v-1.76a1.906 1.906 0 011.9-1.9c1.81 0 2.55-1.28 1.64-2.85a1.9 1.9 0 01.7-2.59l1.73-.99a1.669 1.669 0 012.28.6l.11.19c.9 1.57 2.38 1.57 3.29 0l.11-.19a1.669 1.669 0 012.28-.6l1.73.99a1.9 1.9 0 01.7 2.59c-.91 1.57-.17 2.85 1.64 2.85a1.906 1.906 0 011.9 1.9v1.76a1.906 1.906 0 01-1.9 1.9c-1.81 0-2.55 1.28-1.64 2.85a1.9 1.9 0 01-.7 2.59l-1.73.99a1.669 1.669 0 01-2.28-.6l-.11-.19c-.9-1.57-2.38-1.57-3.29 0l-.11.19a1.669 1.669 0 01-2.28.6l-1.73-.99a1.9 1.9 0 01-.7-2.59c.91-1.57.17-2.85-1.64-2.85a1.906 1.906 0 01-1.9-1.9z"}})])])
          )
        }
      }
    